import type {ReactAction} from '@netx/core/bootstrap';
import {faEye} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartVisibility} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Manage cart asset visibility
 * @param params
 * @returns Action
 */
export const cartActionManageVisibilityShow = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-visibility-show',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.VISIBILITY_SHOW),
	enableTest: canManageCurrentCartVisibility,
	icon: faEye,
	get label() {
		return CART_CURRENT_ACTION_LABELS.VISIBILITY_SHOW;
	},
	...params,
});

export default cartActionManageVisibilityShow;
